import { Component, Input } from "@angular/core";

@Component({
  selector: "ngx-confect-progress-bar",
  templateUrl: "./confect-progress-bar.component.html",
  standalone: false,
})
export class ConfectProgressBarComponent {
  @Input() progressMessage;
  @Input() progressValue;
  @Input() spinner: boolean = true;
  @Input() position: "col" | "inline" = "col";
  @Input() progressMode: "buffer" | "determinate" = "determinate";
}
